<template>
  <div id="distance-fail" type="message">
    <div class="panel-distance-fail">
      <h2 class="page-header">Geen coaches gevonden</h2>
      <div class="panel-text-container">
        <p>Binnen de door jouw opgegeven afstand zijn er geen coaches beschikbaar. Om jouw ideale coach te vinden kun je de maximale reisafstand aanpassen of zoeken via het overzicht van alle coaches.</p>
      </div>
      <div class="buttons-container">
        <button @click="openPanel('TravelDistance')">Afstand aanpassen</button>
        <a href="/overzicht-coaches" class="btn">Naar overzicht coaches</a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AdjustDistance',
  props: {
    openPanel: {
      type: Function
    }
  }
}

</script>
